import { AnyPayload } from '@microsoft/portal-app/lib/redux/AnyPayload';
import { ReducerRegistry } from '@microsoft/portal-app/lib/redux/ReducerRegistry';
import { IAccountAction } from '../models/IAccountAction';
import { IAccountState } from '../models/IAccountState';
import { accountInitialState } from './accountInitialState';

/**
 * Registers the reducers and initial state for the permission area.
 * @description Typically used by reducers in the actions module (i.e folder) to register a reducer that will handle a redux action.
 * After all of the reducers are registers then getReducer can be called (typically by the redux store) that will handle all of the
 * redux actions.  The reducers in the area represent a shared state that an action can influence.
 */
export const accountRegistry = new ReducerRegistry<IAccountAction<AnyPayload>, IAccountState>(accountInitialState);
